import * as trackingEvents from "@goodgamestudios/tracking-event-types";
import { BasicModel } from "../basic/model/BasicModel";
import { EnvGlobalsHandler } from "../basic/EnvGlobalsHandler";
import { BasicTrackingEvent } from "./BasicTrackingEvent";

export class ProfilingTrackingEvent extends BasicTrackingEvent {
    public level: number;
    public fps: number;
    public maxFps: number;
    public memoryUsage: number;

    // mobile parameters
    public deviceId: number;
    public storeId: number;
    public connectionType: string;
    readonly downloadSpeed: number = 0;  // putting in random value since we cant really get it

    constructor(referrer: string) {
        super(referrer);
    }


    public getVars(): trackingEvents.Profiling.Event {
        const vars: trackingEvents.Profiling.Event = {
            eventId: trackingEvents.Profiling.ID,
            event_mapping_version: 2,
            playerId: BasicModel.userData ? BasicModel.userData.playerID : -1,
            level: this.level,
            dlr: this.downloadSpeed, // Kb/s
            fps: this.fps, // frames per second
            deviceId: this.deviceId,
            storeId: this.storeId,
            connectionType: this.connectionType,
            maxFps: this.maxFps,
            memoryUsage: this.memoryUsage
        };
        // fields that are required but not yet added to the Tracking-Definition (which are converted to Tracking Runtypes
        (<any>vars).user_agent= navigator.userAgent || "Not available";
        (<any>vars).session_length_ms = EnvGlobalsHandler.globals.sessionLength * 1000;

        return vars;
    }
}
